const kindTypeLogos: {
  [key: string]: string | undefined
} = {
  // Input/outputs
  aws_s3: 'aws-s3.svg',
  aws_sqs: 'aws-sqs.svg',
  elasticsearch: 'elasticsearch.svg',
  gcp_cloud_storage: 'google-cloud.svg',
  gcp_pubsub: 'google-cloud.svg',
  gcp_bigquery_select: 'google-cloud.svg',
  gcp_bigquery: 'google-cloud.svg',

  kafka: 'kafka.svg',
  kafka_franz: 'kafka.svg',
  nats: 'nats.svg',
  nats_stream: 'nats.svg',
  nats_jetstream: 'nats.svg',
  pulsar: 'pulsar.svg',
  amqp_0_9: 'rabbitmq.svg',

  redis_list: 'redis.svg',
  redis_pubsub: 'redis.svg',
  redis_streams: 'redis.svg',
  redis_hash: 'redis.svg',

  websocket: 'network.svg',
  ethernet: 'network.svg',
  http: 'network.svg',
  http_server: 'network.svg',
  http_client: 'network.svg',
  socket_server: 'network.svg',
  nsq: 'network.svg',
  sftp: 'network.svg',
  socket: 'network.svg',
  nanomsg: 'network.svg',
  beanstalkd: 'network.svg',
  amqp_1: 'network.svg',

  mongodb: 'mongodb.svg',
  cassandra: 'cassandra.svg',
  discord: 'discord.svg',
  // twitter_search: 'twitter.svg',
  subprocess: 'utility.svg',
  stdin: 'utility.svg',
  sequence: 'utility.svg',
  resource: 'utility.svg',
  read_until: 'utility.svg',
  inproc: 'utility.svg',
  broker: 'utility.svg',
  batched: 'utility.svg',
  dynamic: 'utility.svg',
  switch: 'utility.svg',
  sync_response: 'utility.svg',
  stdout: 'utility.svg',
  retry: 'utility.svg',
  parse_mqtt_data: 'utility.svg',
  custom_switch: 'utility.svg',
  reject: 'utility.svg',
  drop: 'utility.svg',
  drop_on: 'utility.svg',
  fallback: 'utility.svg',
  parquet: 'parquet.svg',

  sql_select: 'db.svg',
  sql_raw: 'db.svg',
  sql_insert: 'db.svg',

  hdfs: 'hadoop.svg',
  pusher: 'pusher.svg',
  snowflake_put: 'snowflake.svg',
  aws_sns: 'aws-sns.svg',

  file: 'file.svg',
  csv: 'file.svg',
  mqtt: 'mqtt.svg',
  aws_kinesis: 'aws-kinesis.svg',
  aws_kinesis_firehose: 'aws-kinesis.svg',

  azure_table_storage: 'azure.svg',
  azure_queue_storage: 'azure.svg',
  azure_blob_storage: 'azure.svg',
  aws_dynamodb: 'aws-dynamodb.svg',

  // Processor/caches
  aws_lambda: 'aws-lambda.svg',
  bloblang: 'bloblang.svg',
  mapping: 'bloblang.svg',
  generate: 'bloblang.svg',
  mutation: 'bloblang.svg',
  redis: 'redis.svg',

  xml: 'utility.svg',
  wasm: 'utility.svg',
  try: 'utility.svg',
  while: 'utility.svg',
  workflow: 'utility.svg',
  unarchive: 'utility.svg',
  hex_conversion: 'utility.svg',
  split: 'utility.svg',
  metric: 'utility.svg',
  noop: 'utility.svg',
  msgpack: 'utility.svg',
  sleep: 'utility.svg',
  parse_log: 'utility.svg',
  log: 'utility.svg',
  protobuf: 'utility.svg',
  rate_limit: 'utility.svg',
  select_parts: 'utility.svg',
  schema_registry_encode: 'utility.svg',
  schema_registry_decode: 'utility.svg',
  jq: 'utility.svg',
  jmespath: 'utility.svg',
  javascript: 'utility.svg',
  archive: 'utility.svg',
  insert_part: 'utility.svg',
  dedupe: 'utility.svg',
  grok: 'utility.svg',
  group_by: 'utility.svg',
  group_by_value: 'utility.svg',
  for_each: 'utility.svg',
  manipulate_data: 'utility.svg',
  catch: 'utility.svg',
  cached: 'utility.svg',
  cache: 'utility.svg',
  decompress: 'utility.svg',
  branch: 'utility.svg',
  compress: 'utility.svg',
  json_schema: 'utility.svg',
  awk: 'utility.svg',
  bounds_check: 'utility.svg',
  parallel: 'utility.svg',
  none: 'utility.svg',
  memory: 'utility.svg',
  system_window: 'utility.svg',
  multilevel: 'utility.svg',
  ristretto: 'utility.svg',
  local: 'utility.svg',

  memcached: 'memcached.svg',

  avro: 'avro.svg',
  parquet_encode: 'parquet.svg',
  parquet_decode: 'parquet.svg',
  aws_dynamodb_partiql: 'aws-dynamodb.svg',
}

interface LogoParams {
  type: string
}

export default function Logo({ type }: LogoParams) {
  const logoName = kindTypeLogos[type]
  if (logoName === undefined) {
    return null
  }
  return logoName
}
